import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from "@angular/http";
import 'rxjs/add/operator/toPromise';

import { Fmt } from '../../fmt.service';

@Injectable()
export class ProjectTemplateService {
    constructor(
        public _fmt: Fmt
    ) {}

    public LoadPJTemplates<T>(): Observable<T> {
        let params = new URLSearchParams();

        return this._fmt.HttpGet<T>('/api/v1/get_pj_templates', params)
    }

    public GetSelectWSToShare(tpID: string): Observable<Response> {
        let params = new URLSearchParams();
        params.append('tp_id', tpID);

        return this._fmt.HttpGet('/api/v1/get_all_workspaces_for_templates', params)
    }

    public UpdatePJTemplateNames(params: any): Observable<Response> {
        return this._fmt.HttpPost('/api/v1/update_pj_template_names', params)
    }
    public UpdatePJTemplate(params: any): Observable<Response> {
        return this._fmt.HttpPost('/api/v1/update_pj_template_scope', params)
    }
    public EnablePJTemplate(params: any): Observable<Response> {
        return this._fmt.HttpPost('/api/v1/update_enable_pj_template', params)
    }
}

export interface ProjectTemplate {
    tp_id: string,
    name: string,
    enabled: boolean,
    category: string,
    description: string,
    scope: string,
    allowed_workspaces:  AllowedWorkspace[]
    d_ids: string[],
    w_id: string,
    p_id: string,
    deleted_at: string,
    deleted_by: string,
}

export interface AllowedWorkspace {
    w_id: string,
    name: string,
    can_use: boolean,
    checked?: boolean
}